export default "__VITE_ASSET__CxCaAvE$__"